























import { Prop, Component, Vue } from 'vue-property-decorator';

export interface IHeaderLink {
  title: string;
  items: IHeaderLinkItem[];
}

export interface IHeaderLinkItem {
  title: string;
  href: string;
}

@Component({})
export default class GHeader extends Vue {
  @Prop() protected title!: string;
  @Prop({ default: '/' }) protected titleLink!: string;
  @Prop({ default: () => [] }) protected headerLinks!: IHeaderLink[];
}
